import type { ApiClient } from '../../../shared/api/api-client';
import type { OrgPlanStatus, OrganizationPlanChoiceItem, PlanSwitchPreviewResponse } from '../lib/tariff-org-types';

export async function fetchOrgPlanStatus(client: ApiClient): Promise<OrgPlanStatus> {
  return client.request<OrgPlanStatus>('/organizations/me/plan-status', { method: 'GET' });
}

export async function listOrgPlans(client: ApiClient): Promise<OrganizationPlanChoiceItem[]> {
  const raw = await client.request<OrganizationPlanChoiceItem[] | { items?: OrganizationPlanChoiceItem[] }>(
    '/organizations/me/plans',
    { method: 'GET' }
  );
  if (Array.isArray(raw)) return raw;
  if (raw && typeof raw === 'object' && Array.isArray(raw.items)) return raw.items;
  return [];
}

export async function fetchPlanSwitchPreview(
  client: ApiClient,
  newPlanId: number | string
): Promise<PlanSwitchPreviewResponse> {
  const q = new URLSearchParams({ new_plan_id: String(newPlanId) });
  return client.request<PlanSwitchPreviewResponse>(`/organizations/me/plan-switch-preview?${q.toString()}`, {
    method: 'GET'
  });
}

export async function assignOrgPlan(
  client: ApiClient,
  body: { plan_id: number; use_free_trial: boolean }
): Promise<unknown> {
  return client.request('/organizations/me/plan', { method: 'POST', body });
}

export async function initiateOrgPlanPayment(
  client: ApiClient,
  body: Record<string, unknown>
): Promise<{ payment_url?: string | null }> {
  return client.request('/organizations/me/plan/initiate-payment', { method: 'POST', body });
}

export async function contactOrgManager(client: ApiClient, body: Record<string, unknown>): Promise<Record<string, unknown>> {
  return client.request<Record<string, unknown>>('/organizations/me/contact-manager', { method: 'POST', body });
}

export type InvoiceItem = {
  id: number;
  organization_id: number;
  amount_cents: number;
  currency: string;
  status: string;
  provider: string;
  reference_type: string | null;
  plan_id: number | null;
  plan_name: string | null;
  created_at: string;
  paid_at: string | null;
};

export async function fetchOrgInvoices(client: ApiClient): Promise<InvoiceItem[]> {
  const raw = await client.request<InvoiceItem[] | { items?: InvoiceItem[] }>('/organizations/me/invoices', { method: 'GET' });
  if (Array.isArray(raw)) return raw;
  if (raw && typeof raw === 'object' && Array.isArray(raw.items)) return raw.items;
  return [];
}
